import ancestryApi from "../ancestry"
import familysearchApi from "../familysearch"

const ancestorsApi = (type = "ancestry", ...args) => {
  if (type === "ancestry") {
    return ancestryApi(...args)
  }
  if (type === "familysearch") {
    return familysearchApi(...args)
  }
  throw new Error(`Unknown type: ${type}`)
}

export default ancestorsApi